import { Box } from '@mui/material';
import { AgColor } from '../../Styles/AgColor';
import { useIntl } from 'react-intl';

type AgOrganizationalChipsProps = {
  type: 'single' | 'selected',
  label?: string,
  orgId?: string,
  orgType?: string,
  width?: string;
}

const backgroundColors = {
  single: AgColor.grey4,
  selected: AgColor.blueLight,
  default: AgColor.grey4,
};

const textColors = {
  single: AgColor.grey7,
  selected: AgColor.blueMain,
  default: AgColor.grey7
};

const AgOrganizationalChips = ({
  type,
  label,
  orgId,
  orgType,
  width
}: AgOrganizationalChipsProps) => {
  const messages = useIntl().formatMessage;

  return (
    <Box
      sx={{
        padding: '15px',
        borderRadius: '6px',
        background: backgroundColors[type],
        color: textColors[type],
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        fontWeight: '500',
        width: width ?? 'max-content'
      }}
    >
      {(!!label) && (<Box>{label}</Box>)}
      {
        (!!orgId || !!orgType) &&
        (
          <Box sx={{ display: 'flex', gap: '20px' }}>
            {(!!orgId) && (<Box>{`${messages({ id: 'ORG_ID' })}: `}<span style={{ fontWeight: '300' }}>{`#c${orgId}`}</span></Box>)}
            {(!!orgType) && (<Box>{`${messages({ id: 'TYPE' })}: `}<span style={{ fontWeight: '300' }}>{orgType}</span></Box>)}
          </Box>
        )
      }
    </Box>
  );
};

export default AgOrganizationalChips;